import name from './name'

const selectSliceData = state => state[name]
const selectTemplates = state => selectSliceData(state).templates
const selectGroupCategories = state => selectSliceData(state).groupCategories

export { selectTemplates, selectGroupCategories }
